"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64Decode = exports.base64Encode = exports.isBase64 = exports.fileToBase64 = exports.base64ToFile = void 0;
const buffer_1 = require("buffer");
const base64ToFile = (data, filename) => {
    if (!(0, exports.isBase64)(data, { allowMime: true })) {
        throw new Error('base64 inválido');
    }
    const arr = data.split(',');
    const test = arr[0].match(/:(.*?);/);
    const mime = test && test[1];
    const bstr = atob(arr[1]);
    let count = bstr.length;
    const u8arr = new Uint8Array(count);
    while (count--) {
        u8arr[count] = bstr.charCodeAt(count);
    }
    return new File([u8arr], filename, { type: mime !== null && mime !== void 0 ? mime : undefined });
};
exports.base64ToFile = base64ToFile;
const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
            resolve(fileReader.result);
        };
        fileReader.onerror = (error) => {
            reject(error);
        };
    });
};
exports.fileToBase64 = fileToBase64;
const isBase64 = (v, opts) => {
    var _a, _b, _c, _d;
    const options = {
        allowEmpty: (_a = opts === null || opts === void 0 ? void 0 : opts.allowEmpty) !== null && _a !== void 0 ? _a : false,
        mimeRequired: (_b = opts === null || opts === void 0 ? void 0 : opts.mimeRequired) !== null && _b !== void 0 ? _b : false,
        allowMime: (_c = opts === null || opts === void 0 ? void 0 : opts.allowMime) !== null && _c !== void 0 ? _c : false,
        paddingRequired: (_d = opts === null || opts === void 0 ? void 0 : opts.paddingRequired) !== null && _d !== void 0 ? _d : true,
    };
    if (options.allowEmpty === false && v === '') {
        return false;
    }
    let regex = '(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}==|[A-Za-z0-9+/]{3}=)?';
    const mimeRegex = '(data:\\w+\\/[a-zA-Z\\+\\-\\.]+;base64,)';
    if (options.mimeRequired === true) {
        regex = mimeRegex + regex;
    }
    else if (options.allowMime === true) {
        regex = mimeRegex + '?' + regex;
    }
    if (options.paddingRequired === false) {
        regex = '(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}(==)?|[A-Za-z0-9+\\/]{3}=?)?';
    }
    return new RegExp('^' + regex + '$', 'gi').test(v);
};
exports.isBase64 = isBase64;
const base64Encode = (str) => {
    if (str.length === 0)
        return str;
    const buff = buffer_1.Buffer.from(str);
    return buff.toString('base64');
};
exports.base64Encode = base64Encode;
const base64Decode = (str) => {
    if (str.length === 0)
        return str;
    if (!(0, exports.isBase64)(str))
        return str;
    return buffer_1.Buffer.from(str, 'base64').toString();
};
exports.base64Decode = base64Decode;
